import ReportingOptionState from '../store/schema/ReportingOptionState';
import { action } from 'satcheljs';

export const discardReportingOption = action('discardReportingOption');
export const setReportingState = action(
    'setReportingState',
    (reportingState: ReportingOptionState) => ({
        reportingState,
    })
);
export const saveReportingOptionHelper = action(
    'saveReportingOptionHelper',
    (reportingOptionState: ReportingOptionState) => ({
        reportingOptionState,
    })
);
